import type { SignDoc, SignLife } from "../types";

export function docLife(doc: SignDoc): SignLife {
  if (doc.status === "signed") return "signed";
  if (doc.status !== "sent") return "draft";
  if (doc.wait_next) return "waiting";
  if (doc.viewed_at) return "viewed";
  return "sent";
}

export function statusLabel(doc: SignDoc): string {
  const life = docLife(doc);
  if (life === "signed") return "Signé";
  if (life === "waiting") return "En attente";
  if (life === "viewed") return "Vu";
  if (life === "sent") return "Envoyé";
  return "Brouillon";
}

export function statusClass(doc: SignDoc): string {
  return `sg-chip is-${docLife(doc)}`;
}

export function when(s: string): string {
  const d = new Date(s.includes("T") ? s : s.replace(" ", "T"));
  if (Number.isNaN(d.getTime())) return s;
  return d.toLocaleString("fr-FR", { day: "numeric", month: "short", year: "numeric" });
}

export function signerLabel(doc: SignDoc): string {
  const n = doc.signer_name?.trim();
  return n || "—";
}

export function docWhen(doc: SignDoc): string {
  return when(doc.signed_at || doc.sent_at || doc.created_at);
}

export function clockLine(iso?: string | null, zone = "Europe/Paris"): string {
  if (!iso) return "—";
  const raw = iso.includes("T") ? iso : iso.replace(" ", "T");
  const d = new Date(/Z$|[+-]\d{2}:\d{2}$/.test(raw) ? raw : `${raw}Z`);
  if (Number.isNaN(d.getTime())) return iso;
  const label = d.toLocaleString("fr-FR", {
    timeZone: zone,
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
  return `${label} · ${zone === "UTC" ? "UTC" : "Paris"}`;
}

export function phoneNational(stored: string): string {
  const d = stored.replace(/\D/g, "");
  if (d.startsWith("33") && d.length >= 11) return `0${d.slice(2)}`;
  return stored;
}

export function hashGroups(hex: string): string {
  return hex.replace(/\s/g, "").toLowerCase().replace(/(.{8})/g, "$1 ").trim();
}
